import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { DEFAULTS } from "constants/Defaults";
import { DateFormater } from "functions/dateTimeFormat";
import { TextSlicer } from "functions/textSlicer";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NewsCardItems = ({
  title,
  description,
  publicationDate,
  image,
  id,
  translations,
}) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);


  return (
    <Link to={`/mediaLanding/news/${id}`} className="col-12 ">
      <div className="row">
        <div className="col-12 col-md-4 col-lg-2 mb-3">
          <div className="browsetopic-i-img">
            <img
              className="img-fluid"
              src={image ? `${API_BASE_URL}/${image}` : DEFAULTS.NEWS}
              alt="item-img"
              loading="lazy"
            />
          </div>
        </div>
        <div className="col-12 col-md-8 col-lg-10">
          <div className="browsetopic-dateils">
            <ul>
              <li>
                <span className="main-color">
                  <DateFormater value={publicationDate} />
                </span>
              </li>

              <li>
                <p>
                  <b>
                    <LabelLang
                      id="title"
                      defaultValue={title}
                      translations={translations}
                    />
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <TextSlicer
                    txt={LabelLangString({
                      id: "brief",
                      currentLocale: currentLocale,
                      defaultValue: description,
                      translations: translations,
                    })}
                    max={90}
                  />
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default NewsCardItems;
